import {
  applySnapshot,
  getSnapshot,
  Instance,
  SnapshotIn,
  types,
} from 'mobx-state-tree';
import { LoadingState, LoadingStates } from 'globals/types';
import { temporaryEndpoints } from 'http/endpoints';
import { isStoreInitialized, performSetAction } from 'models/utils/utils';
import { Mobile, MobileProps } from './mobile/mobile';

export interface RedirectsMobileProps {
  data?: MobileProps;
  status: LoadingState;
}

export const RedirectsMobile = types
  .model({
    data: types.optional(Mobile, {}),
    status: types.optional(
      types.enumeration(LoadingStates),
      LoadingState.INITIAL
    ),
  })
  .actions((self) => ({
    set(props: RedirectsMobileProps): void {
      applySnapshot(self, {
        ...getSnapshot(self),
        ...props,
      });
    },
    updateStatus(status: LoadingState): void {
      applySnapshot(self, {
        ...getSnapshot(self),
        status,
      });
    },
    setRedirects(props: Partial<MobileProps>): void {
      applySnapshot(self, {
        ...getSnapshot(self),
        data: { ...self.data, ...props },
      });
    },
  }))
  .actions((self) => ({
    async setRedirectsStore(): Promise<void> {
      await performSetAction({
        store: self,
        endpoint: temporaryEndpoints.developers.redirectsMobile,
      });
    },
  }))
  .actions((self) => ({
    async init(): Promise<void> {
      const { status } = getSnapshot(self);
      if (isStoreInitialized(status)) return;
      await self.setRedirectsStore();
    },
    async update(): Promise<void> {
      await self.setRedirectsStore();
    },
  }))
  .views((self) => ({
    getRedirects(): MobileProps {
      const { data } = self;
      return getSnapshot(data);
    },
  }));

export const redirectsMobile = RedirectsMobile.create();
export type RedirectsMobileSnapshot = SnapshotIn<typeof RedirectsMobile>;
export type RedirectsMobileInstance = Instance<typeof RedirectsMobile>;
export default redirectsMobile;
